import { ref } from 'vue'

const isRouteLoading = ref(false)
const targetRouteName = ref<string>('')

export function useRouteLoading() {
  return {
    isRouteLoading,
    targetRouteName,
    startLoading(routeName: string) {
      targetRouteName.value = routeName
      isRouteLoading.value = true
    },
    stopLoading() {
      isRouteLoading.value = false
    },
  }
}
